// extracted by mini-css-extract-plugin
module.exports = {"like":"CollectionLike_like__QBKP6","like__btn":"CollectionLike_like__btn__bvOMU","like__note":"CollectionLike_like__note__tUFqJ"};